import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { HomeComponent } from './home/home.component';
import { StatusEnrolledComponent } from './status-enrolled/status-enrolled.component';
import { AdminDealerComponent } from './admin-dealer/admin-dealer.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { CancelComponent } from './cancel/cancel.component';
import { CancelConfirmComponent } from './cancel-confirm/cancel-confirm.component';
import { ContactComponent } from './contact/contact.component';
import { EnrollComponent } from './enroll/enroll.component';
import { EnrollConfirmComponent } from './enroll-confirm/enroll-confirm.component';
import { FaqComponent } from './faq/faq.component';
import { ReportsComponent } from './reports/reports.component';
import { ReportTiersComponent } from './report-tiers/report-tiers.component';
import { ReportMonthlyRevenueComponent } from './report-monthly-revenue/report-monthly-revenue.component';
import { ReportEnrolledComponent } from './report-enrolled/report-enrolled.component';
import { TiersComponent } from './tiers/tiers.component';
import { TosComponent } from './tos/tos.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { RequestIntlComponent } from './request-intl/request-intl.component';
import { RequestIntlDealerComponent } from './request-intl-dealer/request-intl-dealer.component';
import { FleetStatusComponent } from './fleet-status/fleet-status.component';
import { DealerStatusComponent } from './dealer-status/dealer-status.component';
import { FleetCustomerComponent } from './fleet-customer/fleet-customer.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { BillingReportComponent } from './billing-report/billing-report.component';
import { PotentialBillingReportComponent } from './potential-billing-report/potential-billing-report.component';

const routes: Routes = [
  {path: 'auto-login', component: AutoLoginComponent},
  {path: '', redirectTo: '/home', pathMatch: 'full'},
  {path: 'home', component: HomeComponent},
  {path: 'status-enrolled', component: StatusEnrolledComponent},
  {path: 'admin-dealer', component: AdminDealerComponent},
  {path: 'admin-home', component: AdminHomeComponent},
  {path: 'cancel', component: CancelComponent},
  {path: 'cancel-confirm', component: CancelConfirmComponent},
  {path: 'contact', component: ContactComponent},
  {path: 'enroll', component: EnrollComponent},
  {path: 'enroll-confirm', component: EnrollConfirmComponent},
  {path: 'faq', component: FaqComponent},
  {path: 'reports', component: ReportsComponent},
  {path: 'report-tiers', component: ReportTiersComponent},
  {path: 'report-monthly-revenue', component: ReportMonthlyRevenueComponent},
  {path: 'report-enrolled', component: ReportEnrolledComponent},  
  {path: 'tiers', component: TiersComponent},
  {path: 'tos', component: TosComponent},
  {path: 'privacy', component: PrivacyComponent},
  {path: 'request-intl', component: RequestIntlComponent},
  {path: 'request-intl-dealer', component: RequestIntlDealerComponent},
  {path: 'fleet-status', component: FleetStatusComponent},
  {path: 'dealer-status', component: DealerStatusComponent},
  {path: 'fleet-customer', component: FleetCustomerComponent},
  {path: 'account-info', component: AccountInfoComponent},
  {path: 'forgot-password', component: ForgotPasswordComponent},
  {path: 'change-password', component: ChangePasswordComponent},
  {path: 'billing-report', component: BillingReportComponent},
  {path: 'potential-billing-report', component: PotentialBillingReportComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }